export default {
      id: "pushpay-logo-usage",
      viewBox: "0 0 204 56",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#pushpay-logo",
      toString: function () {
        return this.url;
      }
    }